<template>
    <v-app>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" lg="3" style="background-color:#1271A6" class="pr-0 pt-0 pl-3" justify="center">
                <CPriAlumnoCabecera v-if="dPriAlumno" :pPriAlumno="dPriAlumno"/>
                <CMatMatriculaListByIdAlumno v-if="$route.params.pIdAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" ref="refMatMatriculaListByIdAlumno"/>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" class="pa-0">
                <CMatriculaByAlumno v-if="$route.params.pIdAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" @fuMatriculaList="fuMatriculaList"/>
            </v-col>
        </v-row>
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import CPriAlumnoCabecera from '@/components/PRI/PriAlumnoCabecera.vue';
import CMatriculaByAlumno from '@/components/Academico/MatriculaByAlumno.vue';
import CMatMatriculaListByIdAlumno from '@/components/Academico/MatMatriculaListByIdAlumno.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'MatriculaByAlumno',
    components: {CPriAlumnoCabecera, CMatriculaByAlumno, CMatMatriculaListByIdAlumno},
    mounted(){
        if(this.$route.params.pIdAlumno)
            this.fuLoad(this.$route.params.pIdAlumno);
    },
    data: () => ({
        dPriAlumno: null,
    }),
    methods: {
        fuMatriculaList(){
            this.$refs.refMatMatriculaListByIdAlumno.fuLoad();
        },
        async fuLoad(p_IdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!){
                            prialumno(IdAlumno: $IdAlumno){
                                Alumno
                                DNI
                                Codigo
                                Celular
                                docs
                                priservicio{
                                    IdServicio
                                    Iniciales
                                    Descripcion
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno,
                    }
                })                
                this.dPriAlumno = response.data.prialumno;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>
